import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../state";
import NotificationService from "../Notification/notificationService";

/**
 * Notification linked to the redux state (notification)
 */
export const Notification = () => {
  const notificationData = useSelector(
    (state: RootState) => state.notification,
  );
  const { close: closeNotification } = NotificationService();

  const handleAlertClose = () => {
    closeNotification();
  };
  return (
    <Snackbar
      open={notificationData.open}
      autoHideDuration={6000}
      onClose={handleAlertClose}
    >
      <Alert
        onClose={handleAlertClose}
        severity={notificationData.severity}
        sx={{ width: "100%" }}
      >
        {notificationData.message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
